import { z } from 'zod'

// Champs requis — pilote le rendu visuel (aria-required, isRequired prop)
export const REQUIRED_FIELDS: readonly string[] = [
    'name',
    'city',
    'object',
    'mail',
]

export const contactFormSchema = z.object({
    name: z
        .string()
        .min(1, { message: "Le champ n'a pas été rempli" })
        .max(100),
    city: z
        .string()
        .min(1, { message: "La ville n'a pas été sélectionnée" })
        .max(100),
    object: z
        .string()
        .min(1, { message: "Le champ n'a pas été rempli" })
        .max(2000),
    mail: z
        .string()
        .email({
            message:
                "Le champ email n'est pas valide. Exemple : utilisateur@domaine.fr",
        })
        .max(254),
    phone: z.string().max(30).optional(),
    knowBy: z.string().max(255).optional(),
    newsletter: z.boolean(),
    attachments: z.array(z.custom<File>()),
})

export type ContactFormValues = z.infer<typeof contactFormSchema>
